/** @jsx jsx */
import { jsx } from "theme-ui";
import getMandatoryEnv from "sites-common/utils/getMandatoryEnv";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { navigate, useLocation } from "@reach/router";
import {
  setUserToken,
  unsetUser,
} from "gatsby-plugin-hfn-profile/state/actions";

const { keycloakConfig } = getMandatoryEnv(["keycloakConfig"]);
const Auth = () => {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const elementRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    import("hfnauth/main");
  }, []);
  const oneauthLogout = useCallback(async () => {
    const params = keycloakConfig;
    if (typeof window !== "undefined") {
      const { userLogout } = await import("hfnauth/main");
      await userLogout(params);
      dispatch(unsetUser());
      localStorage.removeItem("trainerCode");
      localStorage.removeItem("trainerReferralCode");
      navigate("/");
      return true;
    }
    return false;
  }, [dispatch]);
  const updateToken = useCallback(async () => {
    const authData =
      typeof window !== "undefined" ? localStorage.getItem("pstate") : "";
    const newAuthData = authData ? JSON.parse(authData) : "";
    if (!newAuthData?.srcmtoken?.token) {
      return false;
    }
    if (typeof window !== "undefined") {
      const { getRefreshToken } = await import("hfnauth/main");
      await getRefreshToken(keycloakConfig)
        .then(async (res) => {
          if (res?.data?.access_token) {
            dispatch(
              setUserToken({
                ...newAuthData?.srcmtoken,
                token: res?.data?.access_token,
              })
            );
          } else if (await oneauthLogout()) {
            dispatch(unsetUser());
          }
        })
        .catch(() => {
          // //console.log(e);
        });
    }
    return true;
  }, [dispatch, oneauthLogout]);

  useEffect(() => {
    updateToken();
  }, [location.pathname, updateToken]);

  useEffect(() => {
    elementRef.current = document.querySelector("hfn-auth");
    const handleUserLoggedOut = async (event) => {
      if (event?.detail?.loggedOut && (await oneauthLogout())) {
        dispatch(unsetUser());
      }
    };
    const listener = (event) => handleUserLoggedOut(event);
    // Add the event listener when the element is present
    if (elementRef.current) {
      elementRef.current.addEventListener("userLoggedOut", listener);
    }
    //  Cleanup event listener on unmount or when path changes
    return () => {
      if (elementRef.current) {
        elementRef?.current?.removeEventListener("userLoggedOut", listener);
      }
    };
  }, [dispatch, elementRef, oneauthLogout]);
  return (
    <hfn-auth
      ref={elementRef}
      config={JSON.stringify(keycloakConfig)}
      showCancel="true"
      authType={
        path && path?.startsWith("/hfnauth/authorization") ? "" : "on-demand"
      }
    />
  );
};

export default Auth;
